import { I3pService } from '@nuxtDatakodeUtils/services/i3p.service'
import type { I3pServiceInterface } from '@nuxtDatakodeUtils/services/i3p.service.interface'
import { I3pEventsEnum } from '@nuxtDatakodeUtils/types/I3pEvents.enum'
import type { FeatureCollection } from 'geojson'
import type { ApiService } from '@nuxtDatakodeUtils/utils/api.service'
import { Command } from '~/models/Command'

type CommandData = PildomModules.Majic.Data.CommandData

export class CommandI3pService extends I3pService<CommandData> implements I3pServiceInterface {
    readonly type = 'command'
    getModel(): Command {
        return new Command()
    }

    getLayerName(): string {
        return 'Communes'
    }

    override async getGeojson(): Promise<any> {
        const api = this.$api as ApiService
        const res = await api.setRequest({
            url: 'communes?format=geojson&userOnly=true',
            method: 'GET',
        })
        const geojsonData: FeatureCollection = this.geojsonData = res
        this.emitter.emit(I3pEventsEnum.geojsonUpdated, { geojsonData })
        return geojsonData
    }

    public async renewCommand(data: any): Promise<void> {
        await this.createEntity()
        const newData: CommandData | null = this.currentEntity?.data ?? null
        const fieldsName: string[] = ['name', 'matrice_type', 'communes']
        fieldsName.forEach((field: string) => {
            if (newData && data)
                newData[field] = data[field]
        })
        this.setEditMode(true)
    }
}
